import { StyleSheet } from "@react-pdf/renderer";
import variables from "theme/styles/_variables.module.scss";

const tableAsyncStyles = StyleSheet.create({
  page: {
    padding: 15,
  },

  printDate: {
    fontFamily: "MuseoSans",
    fontSize: 9,
    color: variables.black,
    textAlign: "right",
  },

  titleContainer: {
    paddingTop: 10,
    paddingBottom: 30,
    paddingLeft: 5,
  },

  title: {
    fontFamily: "MuseoSans",
    fontWeight: 900,
    fontSize: 18,
    color: variables.darkBlue,
    paddingBottom: 4,
  },

  subTitle: {
    fontFamily: "MuseoSans",
    fontWeight: 700,
    fontSize: 10,
    color: variables.darkGray,
  },

  table: {
    width: "100%",
    fontFamily: "MuseoSans",
    fontSize: 9,
  },

  row: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
  },

  tableHead: {
    borderTop: "none",
    borderBottom: `2px solid ${variables.blueV4}`,
    backgroundColor: variables.white,
    position: "relative",
  },

  rowMainText: {
    paddingLeft: 0,
    marginRight: 16,
    margineft: 16,
  },

  truncateString: {
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  tableCell: {
    fontFamily: "MuseoSans",
    fontWeight: 500,
    color: variables.darkGray,
    borderBottom: `1px solid ${variables.lightGrayV3}`,
    paddingTop: 12,
    paddingBottom: 12,
  },

  tableHeaderCell: {
    fontFamily: "MuseoSans",
    fontWeight: 700,
    fontSize: 11,
    color: variables.gray,
    textTransform: "uppercase",
    position: "relative",
    paddingTop: 12,
    paddingBottom: 12,
  },

  firstHeaderCell: {
    borderTopLeftRadius: 12,
  },

  lastHeaderCell: {
    borderTopRightRadius: 12,
  },

  textNormal: {
    fontSize: 9,
  },

  textSmall: {
    fontSize: 8,
  },

  empty: {},
});
export default tableAsyncStyles;
